import { TFunction } from 'i18next';

import {
  emailValidation,
  passwordValidations,
  phoneNumberValidation,
  required,
} from '@app/dashboard/utils/formValidations';
import {
  getCountryFromDomain
} from '@app/dashboard/utils/getCountryFromDomain';


const country = getCountryFromDomain();

export const PROFILE_INFO_FIELDS = {
  COMPANY_NAME: 'companyName',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  PASSWORD: 'password',
};

export const MODAL_ACTIONS = {
  ADD: 'ADD',
  DELETE: 'DELETE',
} as const;

export const ADD_EMAIL_FIELD_INITIAL_STATE = {
  email: {
    errorMsg: '',
    validations: [emailValidation],
    isValid: false,
    value: '',
  },
};

export const ACCOUNT_STATUS = {
  LIVE: 'live',
  TEST: 'test',
  NO_INTEGRATION: 'noIntegration',
};

export const ACCOUNT_STATUS_BADGE = (T: TFunction) => ({
  [ACCOUNT_STATUS.LIVE]: {
    color: 'green',
    size: 'md',
    text: T('innerLayout.profileDetailsPage.accountStatus.live'),
  },
  [ACCOUNT_STATUS.TEST]: {
    color: 'yellow',
    size: 'md',
    text: T('innerLayout.profileDetailsPage.accountStatus.test'),
  },
  [ACCOUNT_STATUS.NO_INTEGRATION]: {
    color: 'gray',
    size: 'md',
    text: T('innerLayout.profileDetailsPage.accountStatus.noIntegration'),
  },
});

export const PHONE_NUMBER_INITIAL_STATE = {
  [PROFILE_INFO_FIELDS.PHONE_NUMBER]: {
    errorMsg: '',
    validations: [required, phoneNumberValidation(country)],
    isValid: false,
    value: '',
  },
  [PROFILE_INFO_FIELDS.PASSWORD]: {
    errorMsg: '',
    validations: [required, ...passwordValidations],
    isValid: false,
    value: '',
  },
};

export const MODAL_CONFIRMATION_CONFIG = {
  [MODAL_ACTIONS.ADD]: {
    TITLE_LOCALIZE_KEY: 'innerLayout.profileDetailsPage.modal.add.title',
    SUCCESS_MESSAGE_LOCALIZE_KEY:
      'innerLayout.profileDetailsPage.toasters.add.success',
  },
  [MODAL_ACTIONS.DELETE]: {
    TITLE_LOCALIZE_KEY: 'innerLayout.profileDetailsPage.modal.delete.title',
    SUCCESS_MESSAGE_LOCALIZE_KEY:
      'innerLayout.profileDetailsPage.toasters.delete.success',
  },
};
